import Router from "./routes";
import './index.css';

function App() {
  return <Router className="App" />;
}

export default App;
